'use client';

import Image from 'next/image';

import { useNativeLayout } from '~/(tenant)/_components/native/_lib/native-layout-context';

export function BookingChipIcon({ src, alt }: { src: string; alt: string }) {
  const isNativeLayout = useNativeLayout();
  const isLocalMonochromeIcon = /^\/images\/book\/[a-z-]+\.svg$/.test(src);

  if (isNativeLayout && isLocalMonochromeIcon) {
    return (
      <span
        aria-hidden="true"
        className="h-4 w-4 flex-shrink-0 bg-current"
        style={{
          maskImage: `url("${src}")`,
          maskSize: 'contain',
          maskPosition: 'center',
          maskRepeat: 'no-repeat',
          WebkitMaskImage: `url("${src}")`,
          WebkitMaskSize: 'contain',
          WebkitMaskPosition: 'center',
          WebkitMaskRepeat: 'no-repeat',
        }}
      />
    );
  }

  return (
    <Image
      src={src}
      alt={alt}
      width={16}
      height={16}
      className="h-4 w-4 flex-shrink-0"
    />
  );
}
